import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { Router } from '@angular/router';
import { resetPassword } from '@aws-amplify/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocaleService } from 'src/app/services/locale';
import { OtpComponent } from '../shared/otp';
import { ButtonComponent } from '../shared/button';

@Component({
  selector: 'app-confirm',
  imports: [ReactiveFormsModule, CommonModule, OtpComponent, ButtonComponent],
  template: `
    <div class="flex flex-col gap-4 mb-6">
      <div class="text-3xl font-bold">
        {{ locale.register_confirm_otp.heading }}
      </div>
      <div class="text-[#616161]">
        {{ locale.register_confirm_otp.subheading }}
      </div>
      <form [formGroup]="form" (submit)="submit()" class="flex flex-col gap-4 mb-6">
        <div class="flex flex-col gap-2">
          <label class="text-[#616161]">{{
            locale.register_confirm_otp.lbl_confirmation_code
          }}</label>
          <div class="inline-flex gap-4 w-88 md:w-96">
            <app-otp
              id="0"
              label="{{ locale.register_confirm_otp.lbl_confirmation_code }}"
              [control]="form.controls['otp0']"
            ></app-otp>
            <app-otp
              id="1"
              label="{{ locale.register_confirm_otp.lbl_confirmation_code }}"
              [control]="form.controls['otp1']"
            ></app-otp>
            <app-otp
              id="2"
              label="{{ locale.register_confirm_otp.lbl_confirmation_code }}"
              [control]="form.controls['otp2']"
            ></app-otp>
            <app-otp
              id="3"
              label="{{ locale.register_confirm_otp.lbl_confirmation_code }}"
              [control]="form.controls['otp3']"
            ></app-otp>
            <app-otp
              id="4"
              label="{{ locale.register_confirm_otp.lbl_confirmation_code }}"
              [control]="form.controls['otp4']"
            ></app-otp>
            <app-otp
              id="5"
              label="{{ locale.register_confirm_otp.lbl_confirmation_code }}"
              [control]="form.controls['otp5']"
            ></app-otp>
          </div>
        </div>
        <div *ngIf="error.length" class="text-red-500 mt-4">
          {{ error }}
        </div>
        <app-button
          type="submit"
          [disabled]="form.invalid"
          text="{{ locale.register_confirm_otp.button_confirm }}"
        ></app-button>
        <div class="flex w-full justify-center">
          <p
            (click)="resend()"
            class="text-[#616161] hover:text-black cursor-pointer w-fit"
          >
            {{ locale.register_confirm_otp.button_resend_code }}
          </p>
        </div>
      </form>
    </div>

    <div
      *ngIf="popup"
      class="fixed top-0 left-0 size-full bg-black/60 flex justify-center z-50"
    >
      <div
        class="p-4 text-2xl futura m-auto bg-white rounded-lg text-[#043b22]"
      >
        OTP inviata! Controlla la tua casella di posta.
      </div>
    </div>
  `
})
export class ConfirmComponent {
  private router: Router = inject(Router);
  private spinner = inject(NgxSpinnerService);
  private localeService = inject(LocaleService);

  locale = this.localeService.locale();

  error = '';
  username = '';
  popup = false;
  navigation = this.router.getCurrentNavigation();

  form = new FormGroup({
    otp0: new FormControl('', [Validators.required]),
    otp1: new FormControl('', [Validators.required]),
    otp2: new FormControl('', [Validators.required]),
    otp3: new FormControl('', [Validators.required]),
    otp4: new FormControl('', [Validators.required]),
    otp5: new FormControl('', [Validators.required])
  });

  constructor() {
    // Try to get username from navigation state first, then fallback to sessionStorage
    this.username = this.navigation?.extras?.state?.['username'] || sessionStorage.getItem('resetPasswordUsername') || '';

    // Store username in sessionStorage for page refresh scenarios
    if (this.username) {
      sessionStorage.setItem('resetPasswordUsername', this.username);
    }

    // Redirect to forgot password if no username available
    if (!this.username) {
      this.router.navigate(['/forgot']);
    }
  }

  submit = async () => {
    this.spinner.show();

    try {
      const otp = Object.values(this.form.value).join('');

      this.spinner.hide();

      // Store OTP in sessionStorage for page refresh scenarios
      sessionStorage.setItem('resetPasswordOtp', otp);

      this.router.navigate(['/reset'], {
        state: { username: this.username, otp }
      });
    } catch (error) {
      this.spinner.hide();
      this.error = (error as any).message;
    }
  };

  resend = async () => {
    this.form.reset();
    this.error = '';
    this.popup = true;
    setTimeout(() => {
      this.popup = false;
    }, 2000);
    await resetPassword({
      username: this.username
    });
  };

  reset = () => {
    this.error = '';
  };
}
